import {isNull} from 'lodash-es';
import {Data} from '../interface';

export default ({
    repositoryGuid,
    grayInfo,
    neverFullVolume, // 永远不会全量 特殊使用
}: Data) => {
    // 如果grayInfo为null 代表数据没有回来 返回null
    if (isNull(grayInfo)) {
        return null;
    }
    // 如果为undefined 则表示数据回来了 但是没有对应值的返回
    if (!grayInfo) {
        return undefined;
    }
    const {
        isUserInGray,
        blackStatus, blackRepoList = [],
        whiteStatus, whiteRepoList = [],
    } = grayInfo;
    // 如果不传repositoryGuid 表示为用户维度 则直接返回后端处理后的数据
    if (!repositoryGuid) {
        return isUserInGray;
    }
    // 如果传repositoryGuid 表示为知识库维度 如果黑白名单都关闭 则为关闭小流量 返回true
    if (!neverFullVolume && (!blackStatus && !whiteStatus)) {
        return true;
    }
    if (blackStatus && blackRepoList.includes(repositoryGuid)) {
        return false;
    }
    if (whiteStatus && whiteRepoList.includes(repositoryGuid)) {
        return true;
    }
    return false;
};
